module.exports = __webpack_public_path__ + "static/media/thank-you.4b1d4098.svg";